// Module
var code = "<div class=\"input-field\" ng-hide=\"showLogoFields === false || field.schema.displayProperties || field.schema.disabled\"> <fg-image file-id=\"field.schema.value\" alignment=\"field.schema.alignment\"></fg-image> </div> ";
// Exports
export default code;